/** Sub-tabs of the company Location tab, in display order (CWS-1921). */
export type LocationSettingsTab = 'lanes' | 'tunnel' | 'way';

export const LOCATION_SETTINGS_TABS: readonly { id: LocationSettingsTab; label: string }[] = [
  { id: 'lanes', label: 'Lanes' },
  { id: 'tunnel', label: 'Tunnel' },
  { id: 'way', label: 'Way' },
];

export const DEFAULT_LOCATION_SETTINGS_TAB: LocationSettingsTab = 'lanes';

/** Child route of `companies/:companyId` that hosts the location settings. */
export const COMPANY_LOCATION_TAB_PATH = 'location';
